import backofficeService from "../../api/backoffice";

export default {
  list(params = {}) { return backofficeService.Api().get("teacher-time-off", { params }).then(response => response.data); },
  get(id) { return backofficeService.Api().get(`teacher-time-off/${id}`).then(response => response.data); },
  decide(id, data) { return backofficeService.Api().put(`teacher-time-off/${id}/decision`, data).then(response => response.data); },
  pdf(id) { return backofficeService.Api().get(`teacher-time-off/${id}/pdf`, { responseType: "blob" }).then(response => response.data); },
};
